export const Limits = {
  MaxNotesLength: 10000,
  MaxTags: 32,
  MaxTagsLength: 128,
  MaxMedications: 32,
  MaxMedicationNameLength: 128
}